import { Anchor, Card, Flex, Grid, Group, Space, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { NavLink } from "react-router-dom";
import { formatDate } from "@/modules/diagnosticos/components/diagnostico-item/DiagnosticoList";
import { verificationDate } from "@/modules/projetos/components/projeto-form/ProjetoForm";
import useUserStore from "@/modules/users/store";
import useGetQuestionarioItem from "@/src/routes/responder-questionario-externo-page/hooks/useGetQuestionarioFromUrl";
import { DOIS } from "@/utils/constants";
import ColaboradoresConvidados from "./ColaboradoresConvidados";
import ColaboradoresRespondidos from "./ColaboradoresRespondido";

const MAGIC_NUMBER = 1000;
const POS = -2;

type Properties = {
  empresaId: string;
  questionarioId: string;
};

const QuestionarioItem = ({ questionarioId, empresaId }: Properties) => {
  const { pathname } = window.location;
  const urlParameters = pathname.split("/");
  const empresaAtivaId = useUserStore((state) => state.activeEmpresaId);
  const segmentos = pathname.split("/").filter(Boolean);
  const idEmpresaProjeto = segmentos.length > DOIS ? urlParameters.at(-1) : undefined;
  const idProjeto = urlParameters.at(POS);
  const { data: questionario } = useGetQuestionarioItem(empresaId, questionarioId);
  const isSmMarches = useMediaQuery("(max-width: 48em)");

  return (
    <>
      <Space h="md" />
      <Card withBorder shadow="md" style={{ flex: 1, width: isSmMarches ? MAGIC_NUMBER : "100%" }}>
        <Grid align="center">
          <Grid.Col span={4}>
            <Flex mih={50} gap="xs" justify="center" align="flex-start" direction="column" wrap="wrap">
              <Text fw={300} fz="xs">
                Nome do questionário
              </Text>
              <Text fw={500} fz="md">
                {questionario?.nome}
              </Text>
            </Flex>
          </Grid.Col>
          <Grid.Col span={2}>
            <ColaboradoresConvidados questionarioId={questionarioId} />
          </Grid.Col>
          <Grid.Col span={2}>
            <ColaboradoresRespondidos empresaId={empresaId} questionarioId={questionarioId} />
          </Grid.Col>
          <Grid.Col span={2}>
            <Group align={"center"} justify={"center"}>
              <Flex mih={50} gap="xs" justify="center" align="flex-start" direction="column" wrap="wrap">
                <Text fw={300} fz="xs">
                  Período de avaliação
                </Text>
                <Text fw={500} fz="md">
                  {typeof questionario?.dataAtuacao === "number"
                    ? formatDate(verificationDate(new Date()))
                    : formatDate(verificationDate(questionario?.dataAtuacao))}{" "}
                  -{" "}
                  {typeof questionario?.dataVigencia === "number"
                    ? formatDate(verificationDate(new Date()))
                    : formatDate(verificationDate(questionario?.dataVigencia))}
                </Text>
              </Flex>
            </Group>
          </Grid.Col>
          <Grid.Col span={2}>
            <Group align={"center"} justify={"center"}>
              <Anchor
                component={NavLink}
                to={
                  idEmpresaProjeto
                    ? `/questionarioInfo/${empresaAtivaId}/${idProjeto}/${questionario?.id}/${idEmpresaProjeto}`
                    : `/questionariosColaborador/${questionario?.id}`
                }
              >
                Ver mais
              </Anchor>
            </Group>
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
};

export default QuestionarioItem;
